/** Format integer pence as GBP, e.g. 1234 → "£12.34". */
export function formatGbpPence(pence: number): string {
  const pounds = (Number(pence) || 0) / 100;
  return `£${pounds.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
